<template>
  <div class="content">
    <Form :model="formData" ref="form" :label-width="150">
      <FormItem label="开场白">
        <div class="prologues-list">
        <Row :gutter="16" style="width: 100%; margin-bottom: 10px;" v-for="(value, index) in formData.voices" :key="index">
          <Col span="6">
            <FormItem :prop="'voices.' + index + '.name'" :rules="{required: true, message: '开场白不能为空', trigger: 'blur'}">
              <Input v-model="formData.voices[index].name" :disabled="!isEdit || !formData.voices[index].allowNameChange" placeholder="开场白名称"></Input>
            </FormItem>
            <span v-show="!formData.voices[index].allowNameChange">id: {{ formData.voices[index].id }}</span>
          </Col>
          <Col span="15">
            <form-item-voice 
              :disabled="!isEdit"
              :voice="formData.voices[index]"
              @change="voiceChange($event, index)"
              :type="1"
            />
          </Col>
          <Col span="3">
            <div>
              <i-switch :disabled="!isEdit" :loading="loading[formData.voices[index].id]" :value="formData.voices[index].enable" @on-change="(val) => {
                formData.voices[index].enable = val
                if (!val) {
                  forbidPrologue(formData.voices[index].id)
                }
              }"/>
            </div>
            <div>
              <Icon
                v-show="isEdit && formData.voices.length > 1"
                class="var-del-icon"
                color="#ed4014"
                type="ios-trash-outline"
                @click="deletePrologue(formData.voices[index].id)"
              />
            </div>
          </Col>
        </Row>
        </div>
        <Row style="width: 100%;" v-show="isEdit">
          <Col span="22" offset="1">
            <Button type="dashed" long @click="addParameters" icon="md-add"
              >添加开场白</Button
            >
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
        <Button style="margin-left: 8px" v-show="!isEdit" @click="fixDuplicateIds">修复重复ID</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormItemVoice from '../../../components/FormItemVoice.vue'
import { Form } from 'view-design'
import { addNodeId, setNodeIdPool } from '../../../utils/nodeIdPool'
import { getPrologureTaskA } from '../../../server/api'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: { FormItemVoice },
  data() {
    return {
      isEdit: false,
      formData: {
        voices: [{ id: addNodeId('V'), name: '', enable: false, voice: '', text: '', allowNameChange: true }],
      },
      params: [],
      loading: {},
      deleting: {},
      taskInUse: [],
    }
  },
	computed: {
    ...mapState('setting', ['multi_prologue']),
    ...mapState('scene', ['sceneId']),
    ...mapState('flow', ['flows']),
	},
  watch: {
    multi_prologue: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    },
  },
  methods: {
    ...mapActions('setting', ['updateMultiPrologue']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    voiceChange(voice, index) {
      this.formData.voices[index].voice = voice.voice;
      this.formData.voices[index].text = voice.text;
    },
    // 添加参数
    addParameters() {
      this.formData.voices.push({ id: addNodeId('V'), name: '', enable: false, voice: '', text: '', allowNameChange: true });
    },
    resetForm() {
      console.log('this.multi_prologue :>> ', this.multi_prologue);
      this.formData = { ...this.formData, ...cloneDeep(this.multi_prologue) }
    },
    // 判断是否可禁用开场白
    judgePrologue(id) {
      return getPrologureTaskA({
        sceneId: this.sceneId,
        prologueId: id,
      }).then(res => {
        const data = res.data || [];
        if (data.length === 0) {
          return res.data
        } else {
          this.$Modal.warning({
            title: '开场白正在使用中，请先删除相关任务',
            content: data.join('，')
          });
          return Promise.reject()
        }
      })
    },
    forbidPrologue(id) {
      this.$set(this.loading, id, true)
      this.judgePrologue(id).then(res => {
        const index = this.formData.voices.findIndex(item => item.id === id)
        this.$set(this.formData.voices[index], 'enable', false)
      }).catch(() => {
        const index = this.formData.voices.findIndex(item => item.id === id)
        this.$set(this.formData.voices[index], 'enable', true)
      }).finally(() => {
        this.$set(this.loading, id, false)
      })
    },
    deletePrologue(id) {
      this.$set(this.deleting, id, true)
      this.judgePrologue(id).then(res => {
        const index = this.formData.voices.findIndex(item => item.id === id)
        this.formData.voices.splice(index, 1)
      }).finally(() => {
        this.$set(this.deleting, id, false)
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const enableNum = this.formData.voices.filter(item => item.enable).length
        if (enableNum > 5) {
          this.$Message.error('开场白最多只能开启5个')
          return
        }
        // 判断是否重名
        const names = []
        for (let i = 0; i < this.formData.voices.length; i++) {
          if (names.includes(this.formData.voices[i].name)) {
            this.$Message.error(`开场白名称不能重复:${this.formData.voices[i].name}`)
            return
          }
          names.push(this.formData.voices[i].name)
        }
        const comfirm = () => {
          const voices = this.formData.voices.map(item => {
            return {
              ...item,
              allowNameChange: false
            }
          })
          this.formData = {
            ...this.formData,
            voices,
          }
          this.updateMultiPrologue({
            ...this.formData,
          });
          this.isEdit = false;
        }
        const status = !!this.flows?.find((item) => {
          const nodeIndex = item.nodes?.find(
            (node) => node.is_multi_prologue_node && node.name === '开场白',
          );
          return !!nodeIndex;
        });
        if (!status) {
          this.$Modal.confirm({
            title: '请确认动态开场白开关是否开启?',
            onOk: () => {
              comfirm()
            },
          });
          return
        }
        comfirm()
      })
    },
    createParams(val) {
      this.params.push({
        value: val,
        label: val
      })
    },
    fixDuplicateIds() {
      const voices = cloneDeep(this.formData.voices)
      for (const voice of voices) {
        setNodeIdPool(voice.id)
      }
      const seen = new Set()
      const fixed = []
      for (const voice of voices) {
        if (seen.has(voice.id)) {
          const oldId = voice.id
          voice.id = addNodeId('V')
          fixed.push(`${voice.name || '未命名'}: ${oldId} -> ${voice.id}`)
        }
        seen.add(voice.id)
      }
      if (fixed.length === 0) {
        this.$Message.info('未检测到重复ID')
        return
      }
      this.$Modal.confirm({
        title: `检测到 ${fixed.length} 个重复ID，是否修复?`,
        content: fixed.join('<br/>'),
        onOk: () => {
          this.formData = { ...this.formData, voices }
          this.updateMultiPrologue({ ...this.formData })
          this.$Message.success(`已修复 ${fixed.length} 个重复ID`)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}
.var-del-icon {
  cursor: pointer;
}
.prologues-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
  gap: 25px;
}
</style>

